export default __webpack_public_path__ + "static/media/modal2_overlay.2528f8d7.png";